import { IconDefinition } from '@fortawesome/fontawesome-common-types';

export const faChromecastIcon: IconDefinition = {
  prefix: 'fab',
  iconName: 'chromecast',
  // Manual size, because of too small size at automatic import from fab
  icon: [
    417, // width
    417, // height
    [], // ligatures
    'f838', // unicode
    'M447.8 64H64c-23.6 0-42.7 19.1-42.7 42.7v63.9H64v-63.9h383.8v298.6H298.6V448H448c23.6 0 42.7-19.1 42.7-42.7V106.7C490.7 83.1 471.4 64 447.8 64zM21.3 383.6L21.3 383.6l0 63.9h63.9C85.2 412.2 56.6 383.6 21.3 383.6L21.3 383.6zM21.3 298.6V341c58.9 0 106.6 48.1 106.6 107h42.7C170.7 365.6 103.7 298.7 21.3 298.6zM213.4 448h42.7c-.5-129.5-105.3-234.3-234.8-234.6l0 42.4C127.3 255.6 213.3 342 213.4 448z', // svgPathData
  ],
};
